import { Component } from "react"

/* Modal */
import Modal from "react-modal"

/* Components */
import { Icon } from "../../components"

/* Moment */
import moment from "moment"
import "moment/locale/ru"

/* DatePicker */
import DatePicker, { registerLocale } from "react-datepicker"
import ru from "date-fns/locale/ru"

/* Shared */
import { BOOKING_STATUSES, CHANNELS } from "./shared"

registerLocale("ru", ru)
moment.locale("ru")
Modal.setAppElement("#root")


/* The periods the records are looked at by. The month is the one the tab opens on */
export const PERIODS = [
    { key: "month", text: "Этот месяц" },
    { key: "prev", text: "Прошлый месяц" },
    { key: "week", text: "Эта неделя" },
    { key: "today", text: "Сегодня" },
    { key: "year", text: "Этот год" },
    { key: "period", text: "Свой период" }
]


/* The dates one period stands for */
export const periodDates = key => {

    if (key === "today") {
        return { startDate: moment().startOf("day").toDate(), endDate: moment().endOf("day").toDate() }
    }

    if (key === "week") {
        return { startDate: moment().startOf("week").toDate(), endDate: moment().endOf("week").toDate() }
    }

    if (key === "prev") {
        return { startDate: moment().subtract(1, "month").startOf("month").toDate(), endDate: moment().subtract(1, "month").endOf("month").toDate() }
    }

    if (key === "year") {
        return { startDate: moment().startOf("year").toDate(), endDate: moment().endOf("year").toDate() }
    }

    return { startDate: moment().startOf("month").toDate(), endDate: moment().endOf("month").toDate() }
}


/* The filter the tab of the records opens on — the current month, every status, every channel */
export const INITIAL_BOOKING_FILTER = { period: "month", status: "all", channel: "all", ...periodDates("month") }


/* Widget Bookings Filter Modal — the period of the records and what is left of them.
   It is opened by the reference: this._filter.open(filter) */
class BookingsFilterModal extends Component {

    constructor() {
        super()

        this.state = {
            visible: false,
            filter: { ...INITIAL_BOOKING_FILTER }
        }
    }

    /* Open the filter on what the tab is showing now */
    open = filter => {
        this.setState({ visible: true, filter: { ...INITIAL_BOOKING_FILTER, ...filter } })
    }

    /* Close the filter */
    close = () => {
        this.setState({ visible: false })
    }

    /* Choose one value of the filter */
    set = (key, value) => {
        this.setState(previous => ({ filter: { ...previous.filter, [key]: value } }))
    }

    /* Choose the period — its dates are filled in at once */
    period = key => {

        /* The own period keeps the dates which are already chosen */
        if (key === "period") {
            this.set("period", key)
            return
        }

        this.setState(previous => ({ filter: { ...previous.filter, period: key, ...periodDates(key) } }))
    }

    /* Give the chosen filter to the tab */
    apply = () => {

        const { filter } = this.state
        const { onApply } = this.props

        this.setState({ visible: false })
        onApply(filter)
    }

    /* Drop everything back to the current month */
    reset = () => {

        const { onApply } = this.props

        this.setState({ visible: false, filter: { ...INITIAL_BOOKING_FILTER } })
        onApply({ ...INITIAL_BOOKING_FILTER })
    }

    render = () => {

        /* Fields */
        const { visible, filter } = this.state

        return (
            <Modal
                isOpen={visible}
                onRequestClose={this.close}
                className="filter-modal"
                overlayClassName="filter-modal-overlay"
                closeTimeoutMS={200}
            >

                <div className="filter-modal-header">
                    <h2>Фильтры записей</h2>
                    <div onClick={this.close} className="filter-modal-close">
                        <Icon name="close" size={11} width={2.2} />
                    </div>
                </div>

                <div className="filter-modal-body">

                    <div className="filter-modal-row">

                        <div className="filter-modal-row-text">Период</div>

                        <div className="filter-modal-chips">
                            {PERIODS.map(period =>
                                <div
                                    key={period.key}
                                    onClick={() => this.period(period.key)}
                                    className={`filter-modal-chip ${filter.period === period.key ? "active" : ""}`}
                                >
                                    {period.text}
                                </div>
                            )}
                        </div>

                        <div className="filter-modal-dates">

                            <div className="filter-modal-date">
                                <span>С</span>
                                <DatePicker
                                    withPortal
                                    locale="ru"
                                    dateFormat="dd.MM.yyyy"
                                    selected={filter.startDate}
                                    onChange={date => this.setState(previous => ({ filter: { ...previous.filter, period: "period", startDate: date } }))}
                                />
                            </div>

                            <div className="filter-modal-date">
                                <span>По</span>
                                <DatePicker
                                    withPortal
                                    locale="ru"
                                    dateFormat="dd.MM.yyyy"
                                    selected={filter.endDate}
                                    onChange={date => this.setState(previous => ({ filter: { ...previous.filter, period: "period", endDate: date } }))}
                                />
                            </div>

                        </div>

                    </div>

                    <div className="filter-modal-row">

                        <div className="filter-modal-row-text">Статус записи</div>

                        <div className="filter-modal-chips">

                            <div onClick={() => this.set("status", "all")} className={`filter-modal-chip ${filter.status === "all" ? "active" : ""}`}>Все</div>

                            {BOOKING_STATUSES.map(item =>
                                <div
                                    key={`${item.status}`}
                                    onClick={() => this.set("status", item.status)}
                                    className={`filter-modal-chip ${`${filter.status}` === `${item.status}` ? "active" : ""}`}
                                >
                                    {item.text}
                                </div>
                            )}

                        </div>

                    </div>

                    <div className="filter-modal-row">

                        <div className="filter-modal-row-text">Канал записи</div>

                        <div className="filter-modal-chips">

                            <div onClick={() => this.set("channel", "all")} className={`filter-modal-chip ${filter.channel === "all" ? "active" : ""}`}>Все</div>

                            {Object.keys(CHANNELS).map(key =>
                                <div
                                    key={key}
                                    onClick={() => this.set("channel", key)}
                                    className={`filter-modal-chip ${filter.channel === key ? "active" : ""}`}
                                >
                                    {CHANNELS[key]}
                                </div>
                            )}

                        </div>

                    </div>

                </div>

                <div className="filter-modal-footer">
                    <div onClick={() => this.reset()} className="filter-modal-button light">Сбросить</div>
                    <div onClick={() => this.apply()} className="filter-modal-button">Показать</div>
                </div>

            </Modal>
        )
    }
}

export default BookingsFilterModal
